// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:767.98px){.title[data-v-1ae97613]{font-size:1.5rem;line-height:2rem}}", ""]);
// Exports
module.exports = exports;
